'use strict';
import $ from 'jquery';

export default class Footer {
  constructor() {

    function smooth_scroll_to(attr_id) {
      var target = $("#" + attr_id);
      if( target.length ) {
          event.preventDefault();
          $('html, body').stop().animate({
              scrollTop: target.offset().top
          }, 500);
      }
    }

    $(document).on('click', '.js-faq-question', function() {
      var item = $(this).parent('.js-faq-item');
      var answer = $(this).next('.js-faq-answer');

      if (!item.hasClass('-open')){

        $('.js-faq-item.-open').removeClass('-open').find('.js-faq-answer').css({'height': 0}).parent().find('.js-faq-question').attr('aria-expanded', false);
        var new_height = answer.find('div').outerHeight(true);

        answer.css({'height': new_height + 'px'}).parent().find('.js-faq-question').attr('aria-expanded', true);

        item.addClass('-open');
      }
    });

    $(document).on('keypress', '.js-faq-question', function(e) {

      if(e.which == 13) {

        var item = $(this).parent('.js-faq-item');
        var answer = $(this).next('.js-faq-answer');

        if (!item.hasClass('-open')){

          $('.js-faq-item.-open').removeClass('-open').find('.js-faq-answer').css({'height': 0}).parent().find('.js-faq-question').attr('aria-expanded', false);
          var new_height = answer.find('div').outerHeight(true);

          answer.css({'height': new_height + 'px'}).parent().find('.js-faq-question').attr('aria-expanded', true);

          item.addClass('-open');
        }
      }

    });

    $(window).on('load resize', function() {
      var current_item = $('.js-faq-item.-open');
      var current_answer = current_item.find('.js-faq-answer');
      var current_height = current_answer.find('div').outerHeight(true);
      current_answer.css({'height': current_height + 'px'});
    });

    var formFilled = false;
    $(document).on('change', '.js-form', function() {
      if (!formFilled) {
        var form = $(this);

        if (
        form.find('input[name=name]').val() != ''
        || form.find('input[name=email]').val() != ''
        || form.find('input[name=message]').val() != ''
        ) {
          $('.js-form-captcha').show();
          formFilled = true;
        }
      }
    });

    var formSubmitting = false;
    $(document).on('submit', '.js-form', function(event) {

      event.preventDefault();

      if (!formSubmitting) {
        formSubmitting = true;
        var form = $(this);
        form.find('.js-form-button').addClass('-loading');
        form.find('.-error').removeClass('-error');


        var ajaxUrl = 'https://perceelwijzer.nl/processForm.php';
        var formData = {
          'name'       : form.find('input[name=name]').val(),
          'email'      : form.find('input[name=email]').val(),
          'message'    : form.find('textarea[name=message]').val(),
          'captcha'    : grecaptcha.getResponse()
        };

        $.ajax({
          type: "POST",
          url: ajaxUrl,
          data: formData,
          dataType: 'JSON',
          encode: true,
        }).done(function(data) {

          formSubmitting = false;
          form.find('.js-form-button').removeClass('-loading');

          if ( ! data.success) {

            // handle errors for name, email and message
            if (data.errors.name) {
              $('.js-form-name').addClass('-error');
            }

            if (data.errors.email) {
              $('.js-form-email').addClass('-error');
            }

            if (data.errors.message) {
              $('.js-form-message').addClass('-error');
            }

            if (data.errors.captcha) {
              $('.js-form-captcha').addClass('-error');
            }

            grecaptcha.reset();

          } else {

            // SUCCESS
            smooth_scroll_to("signup");
            var formHeight = form.parent().outerHeight();
            form.parent().css({'min-height' : formHeight + 'px'});
            form.hide();
            $('.js-form-message').show();

          }

        }).fail(function(data) {
          formSubmitting = false;
          form.find('.js-form-button').removeClass('-loading');
        });


      }
    });

  }
}
